export default __webpack_public_path__ + "static/media/Scope-1.754a08fc.png";